import React, { useEffect, useRef, useState } from 'react';
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded"
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Box, Flex } from '@chakra-ui/react';
import { TbDoorExit } from "react-icons/tb";
import { resetGetZoomJwtToken, setZoomCallCurrentlyActive, setZoomCallInSession } from '../../organizations/actions/zoom-actions';
import { bindActionCreators } from 'redux';

const EmbeddedZoomMeetingDisplay = ({
  setZoomCallInSession, 
  setZoomCallCurrentlyActive, 
  resetGetZoomJwtToken,
  generatedZoomJwtTokenMetadata, 
  zoomCallIsLive}) => {

  const client = ZoomMtgEmbedded.createClient();
  
  const zoomLaunchRef = useRef(false);
  const meetingSDKRef = useRef(null);
  const [zoomLocalState, setZoomLocalState] = useState("")
  useEffect(() => {
    if (generatedZoomJwtTokenMetadata) {
      setZoomLocalState({ ...generatedZoomJwtTokenMetadata })
      zoomLaunchRef.current = true
      // UUU reset the redux to prevent reusing
   
    }
  }, [generatedZoomJwtTokenMetadata])


  useEffect(() => {

    if (!!zoomLaunchRef.current && zoomLocalState) {
      const { zoomMeetingNumber, zoomJwtSignature, zoomMeetingPassword, zoomDisplayName, zoomClientId } = generatedZoomJwtTokenMetadata || {};

      const joinMeeting = () => {
        client.init({
          zoomAppRoot: document.getElementById('meetingSDKElement'),
          language: 'en-US',
          customize: {
            video: {
              isResizable: false,
              // popper: {
              //   disableDraggable: true
              // },
              viewSizes: {
                default: {
                  width: 240,
                  height: 135
                },
                ribbon: {
                  width: 240,
                  height: 135
                }
              }
            },
            
        toolbar: {
          buttons: [
            {
              text: 'Leave Meeting',
              onClick: () => {
                handleLeaveMeetingButton()
              }
            }
          ]
        }
          }
        })


        client.join({
          appKey: zoomClientId,
          sdkKey: zoomClientId,
          meetingNumber: zoomMeetingNumber,
          signature: zoomJwtSignature, // Generated JWT for authorization
          userName: zoomDisplayName ? zoomDisplayName : "Team member", 
          password: zoomMeetingPassword || ""
        }).then(()=> {
          setZoomCallInSession(true)
          setZoomCallCurrentlyActive(true)
        })
      };

      joinMeeting()
      zoomLaunchRef.current = false;
    }
  }, [zoomLocalState])

const handleLeaveMeetingButton = () => {
  client.leaveMeeting()
  setZoomCallInSession(false)
  resetGetZoomJwtToken()
}

  return (
    <Box
  position='fixed'
  bottom='3em'
  right='3em'
  zIndex='10'
    >
      <Flex id="meetingSDKElement" ref={meetingSDKRef} >
        {/* Zoom Meeting SDK will render here */}
      </Flex>


{zoomCallIsLive && 
      <Flex right='1em' bottom='1em'  justify='flex-end'
      whiteSpace='nowrap' color='white' mt='1em'
       >
        <Flex gap={2}  p='0.25em 0.5em' justify='space-between' align='center'  bg='brandPink.500' rounded='1em' cursor='pointer' onClick={()=>handleLeaveMeetingButton()}>
        <Box as={TbDoorExit} boxSize='0.875em' />
        <Box fontSize='0.875em' whiteSpace='nowrap'>Leave Meeting   </Box> 
        </Flex>
      </Flex>
}
    </Box>
  );
};


function mapStateToProps(state) {
  return {
    generatedZoomJwtTokenMetadata: state.generatedZoomJwtToken.results.data,
    zoomCallIsLive: state.zoomCallInSession.isLive
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setZoomCallInSession,
      setZoomCallCurrentlyActive,
      resetGetZoomJwtToken
    },
    dispatch,
  ) 




export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmbeddedZoomMeetingDisplay));
